<template>
<div>
    <div class="search-top">
        <div class="row">
            <div class="col-md-12">
                <div class="export-right">
                    <div class="export">
                        <h4>Dialer Call Records</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="review-table">
        <table class="display" id="dialerTable">
            <thead>
                <tr>
                    <th>Customer Name</th>
                    <th>Dialed Phone Number</th>
                    <th>Status</th>
                    <th>Recording</th>
                    <th>Date & Time</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="rec in AllRecords" :key="rec.id">
                    <td>{{ rec.customer_name || (rec.first_name ? (rec.first_name + ' ' + (rec.last_name||'')) : '-') }}</td>
                    <td>{{ rec.phone_formatted || rec.phone || rec.dialed_number || '-' }}</td>
                    <td>{{ rec.status || '-' }}</td>
                    <td>
                            <div v-if="rec.recording_url">
                                <a href="javascript:" class="invites" @click.prevent="openRecording(rec)">Play recording</a>
                            </div>
                            <div v-else>N/A</div>
                        </td>
                    <td>{{ rec.formatted_datetime || rec.call_time || rec.date || rec.created_at || '-' }}</td>
                    <td>
                        <div class="navbar btn-group">
                            <a v-if="rec.recording.chat_id" class="btn btn-sm" :href="inboxHref(rec)"><i class="fa fa-inbox mr-1" aria-hidden="true"></i>Inbox</a>
                            <span v-if="!rec.recording.chat_id">-</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- Modal for playing recordings -->
    <div class="modal fade" id="dialerRecordingModal" tabindex="-1" aria-labelledby="dialerRecordingLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="dialerRecordingLabel">{{ selectedRecordingTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img class="img-fluid" src="@/assets/img/close.png" alt="image title">
                    </button>
                </div>
                <div class="modal-body text-center">
                    <div v-if="selectedRecording">
                        <audio controls>
                            <source :src="recording_url + (selectedRecording.recording?.RecordingUrlLocal || selectedRecording.recording_url)" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div v-else>N/A</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $ from "jquery";
import { ref, onMounted } from "vue";
import axios from "axios";

export default {
    setup() {
        let recording_url = "https://api.getstreamly.com/received/voice/";
        let base_url = "http://api.streamly.com/uploads/";
        let AllRecords = ref([]);
        let selectedRecording = ref(null);
        let selectedRecordingTitle = ref('');

        const getDialerRecords = async () => {
            if ($.fn.DataTable.isDataTable("#dialerTable")) {
                $("#dialerTable").DataTable().clear().destroy();
            }

            $('#dialerTable').DataTable({
                "processing": true,
                "serverSide": true,
                language: {
                    emptyTable: "No matching records found",
                    lengthMenu: "Show _MENU_ records per page",
                    zeroRecords: "",
                    info: "Showing _START_ to _END_ of _TOTAL_ records",
                    infoEmpty: "No records available",
                    infoFiltered: "(filtered from _MAX_ total records)",
                },
                "ajax": {
                    "url": axios.defaults.baseUrl + "dialer/call-records/dt",
                    "type": "POST",
                    "headers": {
                        Authorization: "Bearer " + localStorage.getItem('auth_token'),
                    },
                    "data": function (d) {
                        return $.extend({}, d, {
                            'dealer_id': localStorage.getItem('dealer_id'),
                            'location_id': localStorage.getItem('location_id'),
                        });
                    },
                    dataSrc: function (response) {
                        AllRecords.value = response.data;
                        return [];
                    },
                },
                "searching": true,
                "order": [],
                "columns": [],
            });
            $(".display").addClass("nowrap").dataTable();
        }

        const openRecording = (rec) => {
            selectedRecording.value = rec;
            selectedRecordingTitle.value = rec.customer_name || (rec.first_name ? (rec.first_name + ' ' + (rec.last_name||'')) : rec.phone || 'Recording');
            // show modal
            $("#dialerRecordingModal").modal("show");
        }

        const inboxHref = (rec) => {
            const chatId = rec?.recording?.chat_id || '';
            const origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : '';
            return origin + '/inbox/all/' + chatId;
        }
        // phone formatting is handled by backend via `phone_formatted`.
        onMounted(() => {
            getDialerRecords();

            // pause audio when modal closes
            $(document).on('hidden.bs.modal', '#dialerRecordingModal', function () {
                const audio = document.querySelector('#dialerRecordingModal audio');
                if (audio && !audio.paused) {
                    audio.pause();
                    audio.currentTime = 0;
                }
                selectedRecording.value = null;
                selectedRecordingTitle.value = '';
            });
            window.showHideMainLoader(false);
        });

        return {
            AllRecords,
            recording_url,
            base_url,
            selectedRecording,
            selectedRecordingTitle,
            openRecording,
            inboxHref
        }
    }
}
</script>

<style scoped>
.review-table audio{
    width: 120px;
}
</style>

